import { deleteKeysObject, removeDBObjectKeys, tsValidate, tsValidateArray, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { FAQType_Child, FAQType_Parent, FAQType_VideoChild } from './types.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_FAQ_Base = {
    label: tsValidateString(),
};
const Validator_FAQ_Parent = {
    ...Validator_FAQ_Base,
    type: tsValidateValue([FAQType_Parent]),
    childrenIds: tsValidateArray(tsValidateUniqueId),
};
const Validator_FAQ_Child = {
    ...Validator_FAQ_Base,
    type: tsValidateValue([FAQType_Child]),
    answer: tsValidateString(),
};
const Validator_FAQ_VideoChild = {
    ...Validator_FAQ_Base,
    type: tsValidateValue([FAQType_VideoChild]),
    label: tsValidateString(),
    uiLabel: tsValidateString(undefined, false),
    videoUrl: tsValidateString(),
};
const Validator_ModifiableProps = (instance) => {
    if (!instance)
        return '';
    const preDB = removeDBObjectKeys(instance);
    const toValidate = deleteKeysObject(preDB, DBDef_FAQ.generatedProps);
    switch (toValidate.type) {
        case FAQType_Parent:
            return tsValidate(toValidate, Validator_FAQ_Parent);
        case FAQType_Child:
            return tsValidate(toValidate, Validator_FAQ_Child);
        case FAQType_VideoChild:
            return tsValidate(toValidate, Validator_FAQ_VideoChild);
    }
};
const Validator_GeneratedProps = {
    __faqIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_FAQ = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: ['__faqIds'],
    versions: ['1.0.0'],
    dbKey: 'faq',
    entityName: 'Frequently Asked Question',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'frequently-asked-questions'
    },
    backend: {
        name: 'frequently-asked-questions'
    }
};
//# sourceMappingURL=db-def.js.map